/* Content pages: rail and sub-navigation that follow the reading, one-shot chart reveals, ticks and the night log
   kept in this browser, and the guarantee calculator. Nothing here is sent anywhere. */
(function () {
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- rail (sticky on desktop, a dropdown on phones) ---------- */
  var rail = document.querySelector(".rail"), tg = document.querySelector("[data-rail-toggle]");
  if (rail && tg) {
    tg.addEventListener("click", function () { var o = rail.classList.toggle("open"); tg.setAttribute("aria-expanded", String(o)); });
    $$("a", rail).forEach(function (a) { a.addEventListener("click", function () { rail.classList.remove("open"); tg.setAttribute("aria-expanded", "false"); }); });
  }

  /* ---------- the current section, in the rail or the sub-navigation ---------- */
  function spy(links) {
    var items = links.map(function (a) { return { a: a, t: document.getElementById((a.getAttribute("href") || "").slice(1)) }; }).filter(function (x) { return x.t; });
    if (!items.length) return;
    var cur = null, raf = 0;
    function update() {
      raf = 0;
      var best = null;
      items.forEach(function (x) { if (x.t.getBoundingClientRect().top <= 200) best = x; });
      if (!best) { if (cur) { cur.removeAttribute("aria-current"); cur = null; } return; }
      if (best.a === cur) return;
      if (cur) cur.removeAttribute("aria-current");
      cur = best.a; cur.setAttribute("aria-current", "true");
      var sc = cur.closest(".subnav-in"); if (sc) sc.scrollTo({ left: Math.max(0, cur.offsetLeft - 24), behavior: reduce ? "auto" : "smooth" });
    }
    window.addEventListener("scroll", function () { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
    window.addEventListener("resize", update); update();
  }
  spy($$(".rail a[href^='#']")); spy($$(".subnav a[href^='#']"));

  /* ---------- one-shot reveals (chart bars) ---------- */
  var marked = $$("[data-reveal]");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("on"); io.unobserve(e.target); } }); }, { threshold: 0.35 });
    marked.forEach(function (el) { io.observe(el); });
  } else { marked.forEach(function (el) { el.classList.add("on"); }); }

  /* ---------- ticks and the night log, saved in this browser only ---------- */
  var KEY = "silentrin.pages.v1", store = {};
  try { store = JSON.parse(localStorage.getItem(KEY) || "{}") || {}; } catch (e) { store = {}; }
  function persist() { try { localStorage.setItem(KEY, JSON.stringify(store)); } catch (e) {} }
  $$("[data-save]").forEach(function (el) {
    var k = el.getAttribute("data-save");
    if (store[k] !== undefined) { if (el.type === "checkbox") el.checked = !!store[k]; else el.value = store[k]; }
    el.addEventListener(el.type === "text" ? "input" : "change", function () { store[k] = el.type === "checkbox" ? el.checked : el.value; persist(); });
  });
  $$("[data-clear]").forEach(function (b) {
    var label = b.textContent, t = 0;
    b.addEventListener("click", function () {
      if (!t) { b.textContent = "Click again to clear"; t = setTimeout(function () { b.textContent = label; t = 0; }, 4000); return; }
      clearTimeout(t); t = 0; b.textContent = label;
      $$("[data-save^='" + b.getAttribute("data-clear") + "']").forEach(function (el) { if (el.type === "checkbox") el.checked = false; else el.value = el.tagName === "SELECT" ? el.options[0].value : ""; delete store[el.getAttribute("data-save")]; });
      persist();
    });
  });

  /* ---------- the guarantee calculator: night 1 is the day of delivery, night 60 is 59 days later ---------- */
  var d = document.getElementById("deliv"), out = document.getElementById("calcOut");
  if (d && out) {
    var fmt = function (dt) { return dt.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", year: "numeric" }); };
    d.addEventListener("input", function () {
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d.value);
      if (!m) { out.textContent = ""; return; }
      var n1 = new Date(+m[1], +m[2] - 1, +m[3]), n60 = new Date(+m[1], +m[2] - 1, +m[3] + 59);
      out.innerHTML = "<b>Night 1</b> is " + fmt(n1) + ".<br><b>Night 60</b>, the last night to ask for a refund, is " + fmt(n60) + ".";
    });
  }
})();
